var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraduates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 93,
    viewBox: "0 0 91 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5002 5.8125C44.3485 5.8125 43.211 6.0668 42.1304 6.55723L2.2468 24.9574C0.896017 25.5932 0.000235463 27.2279 0.000235463 29.0625C0.000235463 30.8971 0.896017 32.5318 2.2468 33.1676L10.4795 36.9639C8.14758 41.6502 6.82523 47.1902 6.82523 53.0209V58.125C6.82523 63.2836 5.28961 68.6057 3.65445 72.8016C2.73024 75.1629 1.67805 77.4879 0.455235 79.6313C0.000235468 80.4123 -0.127733 81.4295 0.128204 82.3559C0.384142 83.2822 0.981329 83.9725 1.7207 84.2086L10.8207 87.1149C11.4179 87.3147 12.0577 87.1693 12.5838 86.7516C13.1099 86.3338 13.4796 85.6436 13.5934 84.8625C14.8162 77.0883 14.2048 70.1133 13.2948 65.1182C12.8398 62.5389 12.2284 59.9051 11.3752 57.4893V53.0209C11.3752 47.5354 12.8255 42.3586 15.3423 38.2172C17.1765 35.4018 19.551 33.1313 22.3379 31.7326L44.6613 20.5254C45.8273 19.9441 47.1496 20.6707 47.6046 22.1602C48.0596 23.6496 47.4909 25.3389 46.3249 25.9201L24.0015 37.1273C22.2384 38.0174 20.6885 39.3797 19.423 41.0508L42.1162 51.5133C43.1968 52.0037 44.3343 52.258 45.486 52.258C46.6377 52.258 47.7752 52.0037 48.8559 51.5133L88.7537 33.1676C90.1044 32.55 91.0002 30.8971 91.0002 29.0625C91.0002 27.2279 90.1044 25.5932 88.7537 24.9574L48.8701 6.55723C47.7895 6.0668 46.652 5.8125 45.5002 5.8125ZM18.2002 74.1094C18.2002 80.5213 30.4284 87.1875 45.5002 87.1875C60.5721 87.1875 72.8002 80.5213 72.8002 74.1094L70.6248 47.6988L50.4057 57.0352C48.8274 57.7617 47.1638 58.125 45.5002 58.125C43.8366 58.125 42.1588 57.7617 40.5948 57.0352L20.3757 47.6988L18.2002 74.1094Z",
    fill: "#264A80",
    fillOpacity: 0.68
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduates);
export default __webpack_public_path__ + "static/media/graduates.5ba18a01557c0248b2b4b7f44373a3af.svg";
export { ForwardRef as ReactComponent };